const INITIAL_STATE = {
  revenueInMonth: {
    error: null,
    calculating: false,
    data: null,
  },
};

const revenueReducerNew = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CALCULATE_REVENUE_IN_MONTH_REQUESTED':
      return {
        ...state,
        revenueInMonth: {
          ...state.revenueInMonth,
          calculating: true,
          error: null,
        },
      };
    case 'CALCULATE_REVENUE_IN_MONTH_SUCCEEDED':
      return {
        ...state,
        revenueInMonth: {
          ...state.revenueInMonth,
          calculating: false,
          data: action.payload,
        },
      };

    case 'CALCULATE_REVENUE_IN_MONTH_FAILED':
      return {
        ...state,
        revenueInMonth: {
          ...state.revenueInMonth,
          calculating: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};

export default revenueReducerNew;
